var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "trbo-a-top-message" }, [
    _c("h3", { staticClass: "trbo-a-top-message__title" }, [
      _vm._v("\n    " + _vm._s(_vm.title) + "\n  "),
    ]),
    _vm._v(" "),
    _vm.description
      ? _c("div", {
          staticClass: "trbo-a-top-message__description",
          domProps: { innerHTML: _vm._s(_vm.sanitizedDescription) },
          on: { click: _vm.handleDescriptionClick },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }